import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { GoogleIcon } from './GoogleIcon';
import { SocialButton } from './SocialButton';

const styles = (theme) => ({
  google: {
    color: '#757575',
    backgroundColor: '#fff',
    fontFamily: 'Pluto Sans SemiBold',
    boxShadow: 'none',
    border: '1px solid #757575',
    margin: 0,
    height: '37px',
    padding: 0,
    width: '100%',
    [theme.breakpoints.only('xxs')]: {
      fontSize: '13px',
    },
  },
});

const FalseGoogleLoginComponent = ({ classes, openDialog }) => (
  <div className={classes.wrapper}>
    <SocialButton
      className={classes.google}
      icon={GoogleIcon}
      onClick={(e) => openDialog(e, 'createPassword')}
    >
      Sign in with Google
    </SocialButton>
  </div>
);

export const FalseGoogleLogin = withStyles(styles)(FalseGoogleLoginComponent);
